import { SeoPage, SeoReplaceValues } from 'libs/shared-lib/interfaces';
export const LOCATIONS_SEO_DE: SeoPage = {
    title: `${SeoReplaceValues.DEALER_NAME}: Unsere kompetenten Standorte`,
    description: '',
    image: '',
    twitter: {
        card: 'summary',
        title: `${SeoReplaceValues.DEALER_NAME}: Unsere kompetenten Standorte`,
        description: '',
    },
    og: {
        title: `${SeoReplaceValues.DEALER_NAME}: Unsere kompetenten Standorte`,
        description: '',
    },
    robots: {
        noIndex: false,
        noFollow: false,
    },
};
